import projection from '../generated/pw2203f1.json'; import { AcceptanceManifest } from '../types';
export const pw2203f1AcceptanceManifest = projection as AcceptanceManifest;
